<template>
  <div class="contractManagement-chooseAddress-dialog">
    <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="540px" append-to-body>
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="addressForm" :rules="rules" ref="addressForm" label-position="left">
          <el-row>
            <el-form-item :label="$t('crm_finance_address_dialog.shou_huo_ren')" prop="consigneeName">
              <el-input v-model="addressForm.consigneeName"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('crm_finance_address_dialog.lian_xi_dian_hua')" prop="consigneePhone">
              <el-input v-model="addressForm.consigneePhone"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('crm_finance_address_dialog.suo_zai_di_qu')" prop="address">
              <custom-address-select placeholder="" v-model="addressForm.address" ref="address"></custom-address-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('crm_finance_address_dialog.xiang_xi_di_zhi')" prop="detailAddress">
              <el-input v-model="addressForm.detailAddress"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="addAddress">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAddressSelect from '@/components/customAddressSelect.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {
    customAddressSelect,
  },
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },
  data() {
    return {
      visible: false,
      // tableCode: 'lease_program',
      selectLessee: [],
      addressList: [],

      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      addressForm: {
        partnerOrgId: '',
        consigneeName: '',
        consigneePhone: '',
        address: '', // 自用不参与交互
        detailAddress: '', // 详细地址
        deliverAddressId: '', // 地址ID
        // 地址
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        consigneeName: [{ required: true, message: this.$t('Common.com_required') }, { max: 20 }],
        consigneePhone: [
          { required: true, message: this.$t('Common.com_required') },
          { validator: null, message: this.$t('crm_finance_address_dialog.dhhmgsbzq') },
        ], // 应用场景
        address: { required: true, message: this.$t('Common.com_required') }, // 自用不参与交互
        detailAddress: [{ required: true, message: this.$t('Common.com_required') }, { max: 100 }],
      };
    },
  },
  mounted() {
    this.initDialog();
    this.rules.consigneePhone[1].validator = this.$mobilePhoneValidator;
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'contract_add') {
        this.addressForm.partnerOrgId = this.model.data.partnerOrgId;
      }
      if (this.model.type === 'edit') {
        this.addressForm.consigneeName = this.model.data.item.consigneeName;
        this.addressForm.consigneePhone = this.model.data.item.consigneePhone;
        this.setAddress(this.model.data.item, this.addressForm);
        this.addressForm.detailAddress = this.model.data.item.detailAddress;
        this.addressForm.deliverAddressId = this.model.data.id;
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

    // 地址赋值
    setAddress: function (data, form) {
      form.address = [];
      if (data.countryCode) {
        form.address.push(data.countryCode);
      }
      if (data.provinceCode) {
        form.address.push(data.provinceCode);
      }
      if (data.cityCode) {
        form.address.push(data.cityCode);
      }
    },
    putAddress: function (form) {
      const addressMsg = this.$refs.address.getAddressMsg();
      this.$setFormatData(form, addressMsg);
    },
    // 保存基本信息
    addAddress: function () {
      this.$refs.addressForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.putAddress(this.addressForm);
        if (this.model.type === 'contract_add') {
          this.$postJSON(apis.partnerDeliverAddressAddByPartnerOrgId, this.addressForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.closeDialog();
              this.$emit('success', this.selectLessee);
            }
          });
          return;
        }
        if (this.model.type === 'edit') {
          this.$putJSON(apis.partnerDeliverAddressUpdate, this.addressForm).then((res) => {
            if (res.code === 0) {
              this.contractId = res.data;
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.closeDialog();
              this.$emit('success', this.selectLessee);
            }
          });
        } else {
          this.$postJSON(apis.partnerDeliverAddressAdd, this.addressForm).then((res) => {
            if (res.code === 0) {
              this.contractId = res.data;
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.closeDialog();
              this.$emit('success', this.selectLessee);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.contractManagement-chooseAddress-dialog {
  .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 24px;
    .tag {
      width: 4px;
      height: 15px;
      background-color: #00afff;
      left: 0;
    }
  }
}
</style>
